/**
 * Returns the data from the response, unchanged.
 *
 * @param response  - The Axios response object.
 * @returns The data from the response, unchanged.
 */
export function passThroughData(response) {
    return response.data;
}
/**
 * Flattens the JSON API data so data is at the same level as everything else.
 * { data, included, links, meta }
 *
 * @param response - The Axios response object.
 * @returns Flattended data object.
 */
export function flattenJsonAPIData(response) {
    // Pull out the data we may have back
    const responseData = response.data;
    const { data, included, links, meta } = responseData || {};
    const isEntityListCall = Array.isArray(data);
    const isMetaWithinData = data?.meta;
    if (!data) {
        return response.data;
    }
    if (isEntityListCall) {
        // This is a list
        return {
            data,
            included,
            links,
            meta
        };
    }
    if (isMetaWithinData) {
        return {
            ...data,
            included,
            links
        };
    }
    return {
        ...data,
        included,
        links,
        meta
    };
}
/**
 * Returns the passed attributes object and type string wrapped in a data object
 * To be used when generating the data payload for 'create' and 'update' requests.
 *
 * @param attributes - The attributes data object for the request (type is request-specific)
 * @param type - A string indicating the type of request being made
 */
export function formatDataProperties(type, attributes, id) {
    return {
        data: { attributes, type, id }
    };
}
//# sourceMappingURL=data-formatter.js.map